<template>
    <div class="text-xs-center">


        <v-dialog
                @keydown.esc="onCloseDialog"
                persistent
                v-model="$store.getters.searchDialog"
                width="500">
            <v-card>
                <v-card-title
                        class="headline secondary white--text justify-center"
                        primary-title>
                    Επιλογή Σταθμού Courier
                </v-card-title>
                <v-card-text>
                    <v-form @submit.prevent
                            ref="form">
                        <v-layout align-center fill-height justify-space-between row>
                            <v-text-field :rules="postalCode" clearable label="Πληκτρολογήστε τον ΤΚ σας"
                                          prepend-inner-icon="search" required v-model="zipcode"
                                              v-on:keypress="isNumber($event)"></v-text-field>
                            <v-btn @click="searchPostal" color="primary darken-0"  round small>Αναζήτηση</v-btn>
                        </v-layout>
                        <p v-if="messageError" class="caption font-italic red--text">Δεν βρέθηκε εγγραφή. Παρακαλούμε εισάγετε έγκυρο Ταχυδρομικό Κώδικα.</p>
                        <p v-if="searchPostalDialog" class="caption font-italic red--text">Επιλέξτε τον σταθμό courier σύμφωνα με τον Τ.Κ. που εισάγατε. Τα στοιχεία του σταθμού θα εμφανιστούν μέσα στο επόμενο χρονικό διάστημα.</p>
                    </v-form>
                    <v-card class="elevation-6 mb-3" v-if="searchPostalDialog">
                        <v-divider></v-divider>
                        <v-list dense>
                            <v-list-tile>
                                <v-list-tile-content>Courier:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{this.distPointInfo.courrier.name}}
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>Περιοχή:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{this.distPointInfo.description}}
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>Διεύθυνση:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{this.distPointInfo.address}}
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>Τηλέφωνο:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{this.distPointInfo.phones}}
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>Fax:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{this.distPointInfo.fax}}</v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>Ωράριο Λειτουργίας (Καθημερινές):</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{this.distPointInfo.openHoursWeekdays}}
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>Ωράριο Λειτουργίας (Σάββατο):</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{this.distPointInfo.openHoursSaturday}}
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>Σημείο στο Χάρτη:</v-list-tile-content>
                                <v-list-tile-content @click="maps" class="align-end pointerCursor">
                                    <i>Πατήστε Εδώ</i>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-card>
                    <v-layout align-end column fill-height v-if="$store.getters.chooseCourierButton">

                    </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click="onCloseDialog"
                            color="primary darken-0"
                            flat>
                        Ακύρωση
                    </v-btn>

                    <v-btn v-if="$store.getters.chooseCourierButton" @click="addZipCodeToStore" color="primary darken-0" >Επιλογή
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import requests from "../../requests"


    export default {
        name: "SearchPostalCodeComponent",
        components: {},
        data: () => ({
            messageError: false,
            response: '',
            zipcode: '',
            PIN: "123412341234",
            postalCode: [
                v => !!v || '',
                v => /^[1-8][0-9]( *[0-9][0-9]|[0-9] *[0-9])[0-9]$/.test(v) || 'Ο ταχυδρομικός κώδικας δεν είναι έγκυρος'
            ],
            searchPostalDialog: false
        }),
        methods: {
            onCloseDialog() {
                this.$store.commit('setChooseCourierButton', false);
                this.$store.commit('setSearchDialog', false);
                this.$refs.form.resetValidation();
                this.$refs.form.reset();
                this.searchPostalDialog = false
            },
            isNumber: function (evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            maps() {
                var url = 'http://www.google.com/maps/place/' + this.distPointInfo.latitude + ',' + this.distPointInfo.longitude;
                window.open(url, '_blank');

            },
            addZipCodeToStore() {
                this.$store.commit('setCourier', this.response);
                this.$store.commit('setSearchDialog', false);
                this.$refs.form.reset();
                this.searchPostalDialog = false;
                if (this.response.stationId === null) {
                } else {
                    var statementBookGroup = this.$store.getters.statementBookGroup;
                    if (statementBookGroup == null) {
                        statementBookGroup = {courrierId: this.response.stationId};
                    }
                    statementBookGroup.courrierId = this.response.stationId;
                    this.$store.commit('setStatementBookGroup', statementBookGroup);
                    this.$store.commit('setFinalDeclarationflag' , true)
                }
                this.$store.commit('setChooseCourierButton', false);
            },
            callBackSuccessZipCode(response) {
                this.$store.commit('setChooseCourierButton', true);
                this.$store.commit('setCourierInfo', response);
                this.searchPostalDialog = true;
                this.response = response;
                this.messageError = false;
            },
            onRequestErrors() {
                this.searchPostalDialog = false;
                this.$store.commit('setChooseCourierButton', false);
                this.messageError = true;
                this.$refs.form.reset();
            },
            searchPostal() {
                requests.zipCode(this.zipcode, this.callBackSuccessZipCode, this.onRequestErrors)
                //this.searchPostalDialog = true
            }
        },
        computed: {
            distPointInfo: function () {
                return this.$store.getters.courierInfo;
            }
        }

    }
</script>

<style scoped>

</style>